import {
    REDIS_NODES_REQUEST_GET,
    REDIS_NODES_RESPONSE_GET_SUCCESS,
    REDIS_NODES_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/redisNodesConstants";
  
  export const redisNodesShReducer = (state = { redisNodes: {} }, action) => {
    switch (action.type) {
      case REDIS_NODES_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case REDIS_NODES_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          redisNodes: action.payload,
        };
      case REDIS_NODES_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  